module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("bRply"))).then(() => module.bundle.root('hEqeo'));